import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BackButton = ({ label = "Back", fallback = "/" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <button
      data-testid="back-button"
      onClick={() => (location.key === "default" ? navigate(fallback) : navigate(-1))}
      className="mb-8 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ash transition-colors duration-300 hover:text-charcoal"
    >
      <ArrowLeft size={14} /> {label}
    </button>
  );
};
